module.exports = __webpack_public_path__ + "img/61.02286d92.jpg";